import { render, staticRenderFns } from "./UserReborn.vue?vue&type=template&id=4adf4328&scoped=true&"
import script from "./UserReborn.vue?vue&type=script&lang=ts&"
export * from "./UserReborn.vue?vue&type=script&lang=ts&"
import style0 from "./UserReborn.vue?vue&type=style&index=0&id=4adf4328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adf4328",
  null
  
)

export default component.exports